module.exports = __webpack_public_path__ + "img/LuckyEggChika.be7fed09.png";